export default "__VITE_ASSET__ZjShDaPX__"